<template>
    <form method="post">
        <div class="inputs-name">
            <div>
                <label for="input-firstname">Prénom *</label>
                <input
                    v-model="data.user.informations.firstname"
                    :class="v && isError(v.user.informations.firstname) ? 'error' : null"
                    type="text"
                    id="input-firstname"
                    required
                />

                <ErrorMessage
                    v-if="v && isError(v.user.informations.firstname) && data.user.informations.firstname.length === 0"
                    input="input-firstname"
                    message="Ce champ est nécessaire"
                />
                <ErrorMessage
                    v-if="v && isError(v.user.informations.firstname) && data.user.informations.firstname.length > 0"
                    input="input-firstname"
                    message="Caractères uniquement"
                />
            </div>

            <div>
                <label for="input-name">Nom *</label>
                <input
                    v-model="data.user.informations.name"
                    :class="v && isError(v.user.informations.name) ? 'error' : null"
                    type="text"
                    id="input-name"
                    required
                />
                <ErrorMessage
                    v-if="v && isError(v.user.informations.name) && data.user.informations.name.length === 0"
                    message="Ce champ est nécessaire"
                />
                <ErrorMessage
                    v-if="v && isError(v.user.informations.name) && data.user.informations.name.length > 0"
                    message="Caractères uniquement"
                />
            </div>
        </div>

        <label for="input-email">Email *</label>
        <input
            v-model="data.user.contact.email"
            :class="v && isError(v.user.contact.email) ? 'error' : null"
            type="email"
            id="input-email"
            required
        />
        <ErrorMessage
            v-if="v && isError(v.user.contact.email) && data.user.contact.email.length === 0"
            message="Ce champ est nécessaire"
        />
        <ErrorMessage
            v-if="v && isError(v.user.contact.email) && data.user.contact.email.length > 0"
            message="Adresse email incorrect"
        />

        <label for="input-tel">Téléphone *</label>
        <input
            v-model="data.user.contact.tel"
            :class="v && isError(v.user.contact.tel) ? 'error' : null"
            type="tel"
            id="input-tel"
            required
        />
        <ErrorMessage
            v-if="v && isError(v.user.contact.tel) && data.user.contact.tel.length === 0"
            message="Ce champ est nécessaire"
        />
        <ErrorMessage
            v-if="v && isError(v.user.contact.tel) && data.user.contact.tel.length > 0"
            message="Numéro invalide"
        />

        <label for="input-birthday">Date de naissance *</label>
        <InputVCalendar
            :error="v && isError(v.user.informations.birthday)"
            v-model="data.user.informations.birthday"
            id="input-birthday"
        ></InputVCalendar>
        <ErrorMessage
            v-if="v && isError(v.user.informations.birthday)"
            message="Ce champ est nécessaire"
        />

        <label for="input-birthplace">Lieu de naissance *</label>
        <input
            v-model="data.user.informations.birthplace"
            :class="v && isError(v.user.informations.birthplace) ? 'error' : null"
            type="email"
            id="input-birthplace"
            required
        />
        <ErrorMessage
            v-if="v && isError(v.user.informations.birthplace)"
            message="Ce champ est nécessaire"
        />

        <label for="input-address">Adresse *</label>
        <input
            v-model="data.user.location.addressLine1"
            :class="v && isError(v.user.location.addressLine1) ? 'error' : null"
            type="text"
            placeholder="Adresse"
            id="input-address-line1"
            required
        />
        <ErrorMessage
            v-if="v && isError(v.user.location.addressLine1)"
            message="Ce champ est nécessaire"
        />

        <input
            style="margin-top: 1rem"
            v-model="data.user.location.addressLine2"
            type="text"
            placeholder="Complément d'adresse"
            id="input-address-line2"
        />

        <div class="inputs-location">
            <div>
                <input
                    v-model="data.user.location.city"
                    :class="v && isError(v.user.location.city) ? 'error' : null"
                    type="text"
                    placeholder="Ville"
                    id="input-city"
                    required
                />
                <ErrorMessage
                    v-if="v && isError(v.user.location.city)"
                    message="Ce champ est nécessaire"
                />
            </div>

            <div>
                <input
                    v-model="data.user.location.state"
                    type="text"
                    placeholder="État / Province / Région"
                    id="input-state"
                    required
                />
            </div>

            <div>
                <input
                    v-model="data.user.location.zipcode"
                    :class="v && isError(v.user.location.zipcode) ? 'error' : null"
                    type="text"
                    placeholder="Code postal"
                    id="input-zipcode"
                    required
                />
                <ErrorMessage
                    v-if="v && isError(v.user.location.zipcode) && data.user.location.zipcode.length === 0"
                    message="Ce champ est nécessaire"
                />
                <ErrorMessage
                    v-if="v && isError(v.user.location.zipcode) && data.user.location.zipcode.length > 0"
                    message="Code postal invalide"
                />
            </div>
            <div>
                <select
                    v-model="data.user.location.country"
                    :class="v && isError(v.user.location.country) ? 'error' : null"
                    name="country"
                    id="input-address-country"
                    required
                >
                    <option
                        v-for="(country, index) in countries"
                        :key="index"
                        :value="country"
                    >{{ country }}</option>
                </select>
                <ErrorMessage
                    v-if="v && isError(v.user.location.country)"
                    message="Ce champ est nécessaire"
                />
            </div>
        </div>
    </form>
</template>

<script>
import countriesJson from '../../assets/countries-FR.json';
import { state } from "../../store";
import { isError } from '../../validation';
import ErrorMessage from '../errors/ErrorMessage.vue';
import InputVCalendar from '../Inputs/InputVCalendar.vue';

export default {
    name: "FirstStep",
    components: { ErrorMessage, InputVCalendar },
    props: {
        v: {
            type: Object
        }
    },
    setup() {
        const countries = countriesJson;
        const data = state;

        return { countries, data, isError };
    }
}
</script>

<style lang='scss' scoped>
.inputs-name {
    display: flex;
    div {
        label {
            display: block;
        }

        &:last-child {
            margin-left: 1rem;
        }
    }
}
.inputs-location {
    display: flex;
    flex-wrap: wrap;

    div {
        input,
        select {
            width: 80%;
            margin-top: 1rem;
        }
    }
}
</style>
